import { useState } from 'react';
import { useMutation } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import Field from '@/components/common/Field.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';
import { PORTAL_CREAR_TICKET } from './gql.js';

const FORM_ID = 'portal-ticket-form';

export default function PortalTicketNuevoPage() {
  const [form, setForm] = useState({ clienteId: '', referenciaId: '', referenciaTipo: 'REMITO', asunto: '', descripcion: '' });
  const [message, setMessage] = useState(null);
  const [, crearTicket] = useMutation(PORTAL_CREAR_TICKET);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.clienteId || !form.asunto) {
      alert('Completá cliente y asunto');
      return;
    }
    const result = await crearTicket({
      input: {
        clienteId: Number(form.clienteId),
        referenciaTipo: form.referenciaTipo,
        referenciaId: form.referenciaId ? Number(form.referenciaId) : null,
        asunto: form.asunto,
        descripcion: form.descripcion,
      },
    });
    if (result.error) {
      setMessage({ type: 'error', text: result.error.message });
    } else {
      setMessage({ type: 'success', text: `Ticket #${result.data.portalCrearTicket.id} creado correctamente.` });
      setForm({ clienteId: form.clienteId, referenciaId: '', referenciaTipo: form.referenciaTipo, asunto: '', descripcion: '' });
    }
  };

  return (
    <div className="w-full">
      <PageHeader title="Nuevo reclamo" subtitle="Creá un ticket asociado a tu envío" />
      <form id={FORM_ID} onSubmit={handleSubmit} className="mx-auto mt-6 grid w-full max-w-[700px] grid-cols-12 gap-4">
        <section className="col-span-12 space-y-4 rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
          <Field label="Cliente" htmlFor="cliente" required>
            <input
              id="cliente"
              type="number"
              value={form.clienteId}
              onChange={event => setForm(prev => ({ ...prev, clienteId: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Tipo de referencia" htmlFor="referenciaTipo">
            <select
              id="referenciaTipo"
              value={form.referenciaTipo}
              onChange={event => setForm(prev => ({ ...prev, referenciaTipo: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            >
              <option value="REMITO">Remito</option>
              <option value="PARADA">Parada</option>
              <option value="OTRO">Otro</option>
            </select>
          </Field>
          <Field label="ID referencia" htmlFor="referenciaId">
            <input
              id="referenciaId"
              type="number"
              value={form.referenciaId}
              onChange={event => setForm(prev => ({ ...prev, referenciaId: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Asunto" htmlFor="asunto" required>
            <input
              id="asunto"
              value={form.asunto}
              onChange={event => setForm(prev => ({ ...prev, asunto: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Descripción" htmlFor="descripcion">
            <textarea
              id="descripcion"
              rows={4}
              value={form.descripcion}
              onChange={event => setForm(prev => ({ ...prev, descripcion: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          {message ? (
            <p className={`text-sm ${message.type === 'error' ? 'text-rose-500' : 'text-emerald-500'}`}>{message.text}</p>
          ) : null}
        </section>
      </form>

      <StickyActions>
        <div className="flex w-full items-center justify-end">
          <button
            type="submit"
            form={FORM_ID}
            className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Crear reclamo
          </button>
        </div>
      </StickyActions>
    </div>
  );
}
